import { useTradingSession } from "#/services/kyan/hooks/useTradingSession";
import { useHasSeenOneClickTradingModal } from "#/store/app/portfolio/settings/hasSeenOneClickTradingModal";
import { useShowOneClickTradingModal } from "#/store/app/portfolio/settings/showOneClickTradingModal";

export const useOneClickTradingModalController = () => {
  const { showOneClickTradingModal, setShowOneClickTradingModal } =
    useShowOneClickTradingModal();
  const { hasSeenOneClickTradingModal, setHasSeenOneClickTradingModal } =
    useHasSeenOneClickTradingModal();
  const {
    isTradingSessionEnabled,
    createSession,
    isCreatingSession,
    deleteSession,
    isDeletingSession,
    isOneClickTradingDisabled,
  } = useTradingSession();

  const handleClick = () => {
    if (!hasSeenOneClickTradingModal) {
      setShowOneClickTradingModal(true);
      setHasSeenOneClickTradingModal(true);
      return;
    }

    if (isTradingSessionEnabled) {
      deleteSession();
    } else {
      createSession();
    }
  };

  const isLoading = isCreatingSession || isDeletingSession;

  return {
    isDisabled: isOneClickTradingDisabled,
    setShowOneClickTradingModal,
    showOneClickTradingModal,
    handleClick,
    isLoading,
    isTradingSessionEnabled,
  };
};
